






























import { Vue, Component } from "vue-property-decorator";
import { User } from "@/components/User";

@Component
export default class Apps extends Vue {
  get User() : User {
    return this.$store.getters.User;
  }
  get SelectedApp() : string {
    return this.$store.getters.SelectedApp;
  }
  set SelectedApp(app:string) {
    this.$store.commit('notifyChange', {
      SelectedApp: app
    });
  }

  async logout() {
    try {
      await this.User.logout();
      this.SelectedApp = 'login';
    } catch (error) {
      console.log(error);
    }
  }
}
